import classNames from 'classnames';
import React from 'react';
import { useStoreState } from '../../store';
import Header from './header/Header';
import { isNavbarHidden } from './header/useAppHeaderNav';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const PageShell: React.FC<Props> = ({ children, className }) => {
  const navbar = useStoreState(state => state.orgContext.navbar);
  const showHeader = !isNavbarHidden(navbar);

  return (
    <div className={classNames('page-shell', className)}>
      {showHeader && <Header />}
      {children}
    </div>
  );
};

export default PageShell;
